module.exports = __webpack_public_path__ + "static/media/23.b0c4fea9.png";